import React from 'react';

export default function SuggestionChips({ suggestions, onSelect }) {
  if (!Array.isArray(suggestions) || suggestions.length === 0) return null;
  return (
    <div className="suggestion-chips" data-testid="suggestion-chips" role="group" aria-label="Suggested responses">
      {suggestions.map((suggestion, i) => (
        <button
          key={`${suggestion}-${i}`}
          type="button"
          className="suggestion-chip"
          onClick={() => onSelect && onSelect(suggestion)}
          data-testid={`suggestion-chip-${i}`}
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
}
